module.exports = require("react-collapse");